import { useQuery } from '@tanstack/react-query'
import { Wifi, WifiOff, ServerOff } from 'lucide-react'
import { useOnline } from '@/hooks/use-online'
import { getReadiness } from '@/lib/api/client'
export function ConnectionStatus() {
  const online = useOnline()
  const readiness = useQuery({
    queryKey: ['health', 'ready'],
    queryFn: getReadiness,
    refetchInterval: 30_000,
    enabled: online,
  })
  const state = !online
    ? { Icon: WifiOff, label: 'ออฟไลน์', color: 'warning' }
    : readiness.isError
      ? { Icon: ServerOff, label: 'API ไม่พร้อม', color: 'warning' }
      : readiness.isPending
        ? { Icon: Wifi, label: 'กำลังตรวจสอบ', color: 'neutral' }
        : { Icon: Wifi, label: 'เชื่อมต่อแล้ว', color: 'success' }
  return (
    <span className={`connection-status ${state.color}`} role="status">
      <state.Icon size={15} />
      {state.label}
    </span>
  )
}
